import { PreviewProvider } from '~/contexts/PreviewContext'
import { LayoutProps } from '~/types/layout'

const ScreenLayout = ({ children }: LayoutProps) => {
  return (
    <PreviewProvider>
      <main className="flex h-screen w-full flex-col items-center justify-center p-[2vw]">{children}</main>
    </PreviewProvider>
  )
}

export default ScreenLayout
